import { render, staticRenderFns } from "./earrings.vue?vue&type=template&id=b6520518&scoped=true"
import script from "./earrings.vue?vue&type=script&lang=js"
export * from "./earrings.vue?vue&type=script&lang=js"
import style0 from "./earrings.vue?vue&type=style&index=0&id=b6520518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6520518",
  null
  
)

export default component.exports